function setupFileUpload() {
    document
        .querySelectorAll('input[data-fieldtype="fileUpload"]')
        .forEach((el) => {
            let files = [];
            const fileInput = document.getElementById(el.id);
            const addBtn = document.getElementById("btn-add_" + el.id);
            const notice = document.getElementById(el.id + "_notice");
            const fileUploads = document.getElementById(
                "fileUploadContainer_" + el.id
            );
            const existingFileUploads = document.getElementById(
                "fileUploadContainer2_" + el.id
            );
            const multiple = fileInput.hasAttribute("multiple");

            let previouslyUploaded = getPreviouslyUploadedFiles(el.id);
            if (previouslyUploaded.length > 0) {
                renderExistingFileList();
            }

            function getPreviouslyUploadedFiles(fieldId) {
                const selector = `input[type="hidden"][name^="${fieldId}_file_"]`;
                const hiddenInputs = document.querySelectorAll(selector);

                const uploaded = [];

                hiddenInputs.forEach((input) => {
                    const fullName = input.name;
                    const fileName = fullName.replace(`${fieldId}_file_`, "");
                    uploaded.push({
                        name: fileName,
                        encryptedPath: input.value,
                    });
                });

                return uploaded;
            }

            function addFiles(newFiles, multiple) {
                previouslyUploaded = [];

                if (!multiple) {
                    files = [newFiles.item(newFiles.length - 1)];
                    return;
                }

                const existingNames = new Set(files.map((file) => file.name));

                for (const file of newFiles) {
                    if (!existingNames.has(file.name)) {
                        files.push(file);
                        existingNames.add(file.name);
                    }
                }
            }

            function updateFileInput() {
                const dataTransfer = new DataTransfer();
                files.forEach((file) => dataTransfer.items.add(file));
                fileInput.files = dataTransfer.files;
            }

            function formatFileSize(bytes) {
                if (bytes < 1024) return bytes + " B";
                if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
                return (bytes / (1024 * 1024)).toFixed(2) + " MB";
            }

            function renderExistingFileList() {
                notice?.classList.toggle("d-none", previouslyUploaded.length === 0);

                if (existingFileUploads) {
                    existingFileUploads.innerHTML = "";

                    previouslyUploaded.forEach((file, _) => {
                        const wrapper = document.createElement("div");
                        wrapper.className = "file-upload__item";

                        const infoContainer = document.createElement("div");
                        infoContainer.classList.add("file-upload__info");

                        const nameSpan = document.createElement("span");
                        nameSpan.className = "file-upload__name";
                        nameSpan.textContent = file.name;
                        infoContainer.appendChild(nameSpan);

                        wrapper.appendChild(infoContainer);
                        existingFileUploads.appendChild(wrapper);
                    });
                }
            }

            function renderFileList() {
                fileUploads.innerHTML = "";

                files.forEach((file, index) => {
                    const wrapper = document.createElement("div");
                    wrapper.className = "file-upload__item";

                    const infoContainer = document.createElement("div");
                    infoContainer.classList.add("file-upload__info");

                    const nameSpan = document.createElement("span");
                    nameSpan.className = "file-upload__name";
                    nameSpan.textContent = file.name;
                    infoContainer.appendChild(nameSpan);

                    const sizeSpan = document.createElement("span");
                    sizeSpan.className = "file-upload__size";
                    sizeSpan.textContent = formatFileSize(file.size);
                    infoContainer.appendChild(sizeSpan);
                    

                    const deleteBtn = document.createElement("button");
                    deleteBtn.type = "button";
                    deleteBtn.className = "file-upload__btn file-upload__btn-delete";

                    const deleteSpan = document.createElement("span");
                    deleteSpan.classList.add("visually-hidden");
                    deleteSpan.textContent = `bestand '${file.name}' verwijderen?`;
                    deleteBtn.appendChild(deleteSpan);

                    deleteBtn.addEventListener("click", function () {
                        files.splice(index, 1);
                        updateFileInput();
                        renderFileList();
                    });
                    wrapper.appendChild(infoContainer);
                    wrapper.appendChild(deleteBtn);
                    fileUploads.appendChild(wrapper);
                });
            }

            fileInput.addEventListener("change", function () {
                addFiles(fileInput.files, multiple);
                updateFileInput();
                renderFileList();
                renderExistingFileList();
            });

            addBtn.addEventListener("click", function () {
                fileInput.click();
            });
        });
}

setupFileUpload();
